import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const interviewQuestionsGet = (categoryId = null, includeInactive = false) => {
	const params = new URLSearchParams();
	params.append("includeInactive", !!includeInactive);
	if (categoryId) params.append("categoryId", categoryId);
	const qs = params.toString();
	return axios.get(`${apiUrl}ats/interview-questions${qs ? `?${qs}` : ""}`);
};

export const interviewQuestionGetById = (id) =>
	axios.get(`${apiUrl}ats/interview-questions/${id}`);

export const interviewQuestionCreate = (data) =>
	axios.post(`${apiUrl}ats/interview-questions`, data);

export const interviewQuestionUpdate = (id, data) =>
	axios.put(`${apiUrl}ats/interview-questions/${id}`, data);

export const interviewQuestionDelete = (id) =>
	axios.delete(`${apiUrl}ats/interview-questions/${id}`);

export const interviewQuestionPromote = (data) =>
	axios.post(`${apiUrl}ats/interview-questions/promote`, data);
